import React from 'react';

const QuestionSetSummaryIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
                x="2.5"
                y="3.5"
                width="15"
                height="13"
                rx="1.5"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.5 7.5H17.5"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.5 7.5V16.5"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.5 10.5H14.5"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.5 13.5H14.5"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default QuestionSetSummaryIcon;
